/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { useHasAppliedFilters } from '../../../controllers/top-filter';
import image from './assets/magnifying_glass.svg';
import messages from './messages';

const NoMatches = () => {
	const [isFilterActive, filterStoreActions] = useHasAppliedFilters();
	const { formatMessage } = useIntl();
	return (
		<div css={containerStyles}>
			<img src={image} alt="" width="110" height="84" />
			<Heading size="medium">{formatMessage(messages.noResults)}</Heading>
			{isFilterActive ? (
				<>
					<span css={explanationStyles}>{formatMessage(messages.explanationActiveFilter)}</span>
					<Box xcss={buttonWrapperStyles}>
						<Button
							appearance="primary"
							onClick={() => {
								filterStoreActions.resetAllFilters();
							}}
						>
							{formatMessage(messages.clearFilter)}
						</Button>
					</Box>
				</>
			) : (
				<>
					<span css={explanationStyles}>{formatMessage(messages.explanationNoFilter)}</span>
					<span css={explanationStyles}>
						<a href="https://support.atlassian.com/jira-software-cloud/docs/enable-deployments/">
							{formatMessage(messages.learnMore)}
						</a>
					</span>
				</>
			)}
		</div>
	);
};

const containerStyles = css({
	paddingTop: token('space.200', '16px'),
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.neutral.subtle', colors.N0),
});

const explanationStyles = css({
	marginTop: token('space.200', '16px'),
	textAlign: 'center',
});

const buttonWrapperStyles = xcss({
	marginTop: 'space.200',
});

export default NoMatches;
